import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var CollapseBuilder = /*#__PURE__*/function () {
  function CollapseBuilder() {
    _classCallCheck(this, CollapseBuilder);
  }

  _createClass(CollapseBuilder, null, [{
    key: "BuildCollapse",
    value: //static _toggleCollapse(event) {
    //	const $collapseLabel = event.currentTarget;
    //	$collapseLabel.innerText = $collapseLabel.previousElementSibling.checked ? 'Show Description' : 'Hide Description';
    //}
    function BuildCollapse(id, description, noDescriptionText, showDescriptionText, hideDescriptionText) {
      return "<div class=\"collapse--wrapper\">\n\t\t\t<input id=\"collapse-".concat(id, "\" class=\"collapse--toggle\" type=\"checkbox\">\n\t\t\t<label for=\"collapse-").concat(id, "\" class=\"collapse--label hide\">").concat(hideDescriptionText, "</label>\n\t\t\t<label for=\"collapse-").concat(id, "\" class=\"collapse--label show\">").concat(showDescriptionText, "</label>\n\t\t\t<div class=\"collapse--content\">\n\t\t\t\t<p class=\"mpp-subscriptions--description\">").concat(description === null ? noDescriptionText : description, "</p>\n\t\t\t</div>\n\t\t</div>");
    }
  }]);

  return CollapseBuilder;
}();